import React from "react";
import {
  CardActions,
  ListButton,
  SimpleShowLayout,
  TextField,
  Show,
  EditButton,
} from "react-admin";

import HtmlToReact from 'html-to-react'
var HtmlToReactParser = HtmlToReact.Parser;
var htmlToReactParser = new HtmlToReactParser();

const Questions =({record})=>{
  console.log(record)
  var questions  = [];
  if(record && record.question){
    try{
      questions =JSON.parse(record.question) 
    } catch(e) {
      //console.log(e)
      questions = record.question;
    };
  }
  console.log(questions)
  
  return(
    <div>
    {questions && questions.map((item, index) =>(
          
          <p key={index}><font color="navy" size="2">
          <span>{htmlToReactParser.parse(item['passage'])}</span>
          &nbsp;{index+1}).&nbsp;
          {item['quest']}<br/></font>
          {item['Choices'] && item['Choices'].map((ans, i)=><span  key={i+500}>&nbsp;&nbsp;&nbsp;&nbsp;<font color={ans['isAnswere']? "green" : "grey"} size="2">{i + 1}. {ans['answer']}<br/></font></span>)}
        </p>
    ))
    }
   </div>
  )
  }

const QuestionActions = ({ basePath, data, resource }) => (
  <CardActions>
    <EditButton basePath={basePath} record={data} />
    <ListButton basePath={basePath} />
  </CardActions>
);

export const QuestionShow = (props) => (
  <Show actions={<QuestionActions />} {...props} title="Question">
    <SimpleShowLayout>
      <TextField source="training_name" label="Training" />
      <TextField source="exam_name" label="Exam Name" />
      <Questions  />
      <TextField source="passing_percentage" label="Passing Percentage" />
      <TextField source="comments" label="Comments" />
    </SimpleShowLayout>
  </Show>
);

export default QuestionShow;
